import { useEffect, useRef, useState } from "react";
import { FiUpload } from "../../../assets/icons/vander";
import { useCalendarStore, useForm } from "../../../hooks";
import { useFormMessages } from "../../hooks";
import { ErrorMessage } from "../../ui";

const formValidations = {};

export const UploadInformedConsent = ({ scheduleEventId }) => {
  // Datos del hook ----------------------------------------//
  const {
    //Props
    message,

    //Methods
    startUpdateInformedConsent,
  } = useCalendarStore();

  // States ------------------------------------------------//
  const fileInputRef = useRef();
  const [formData] = useState({
    id: scheduleEventId,
    file: [],
  });

  // Formulario --------------------------------------------//
  const { formState, onFileInputChange } = useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
  });

  const { file } = formState;

  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (file.length > 0) {
      setFormSubmitted(true);
      startUpdateInformedConsent(formState);
    }
  }, [file]);

  return (
    <>
      <div
        className="d-flex justify-content-between align-items-center border rounded border-gray-200"
        style={{ padding: "6px 12px", cursor: "pointer" }}
        onClick={() => fileInputRef.current.click()}
      >
        <div>Subir consentimiento informado</div>
        <input
          type="file"
          name="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={onFileInputChange}
          accept="application/pdf,image/*"
        />
        <FiUpload className="icons" />
      </div>
      {Array.from(file).map((file, index) => (
        <p className="mb-0" key={index}>
          {file.name}
        </p>
      ))}
      {showErrorMessage && (
        <ErrorMessage className={"mt-3"}>{messageText}</ErrorMessage>
      )}
    </>
  );
};
